import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import { useAlert } from "../../../../Context/AlertContext";
import useToastError from "../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import TableData from "../../../../Components/Common/TableData";
import { NewsApiUrls } from "../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";

const NewsRow = ({ row, mutate, onEditClick }) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    NewsApiUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the news "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };
  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.title}</TableData>
        <TableData>
          <span className="block w-40 truncate">{row.description}</span>
        </TableData>
        <TableData>{row?.category?.title}</TableData>
        <TableData>{row?.slug}</TableData>
        <TableData>
          <span className="block w-40 truncate">{row.link}</span>
        </TableData>

        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row)}
          onDelete={handleDelete}
        />
      </TableRow>
    </>
  );
};

export default NewsRow;
